import cjPontanegraApi from '../apis/cjPontanegraApi';

export const deleteAdvertisementsService = async (
  advertisementId: string,
): Promise<void> => {
  await cjPontanegraApi.delete(`/announcements/${advertisementId}`);
};
